module.exports = __webpack_public_path__ + "static/media/singleUser.b0054a50.svg";